import { faPlus, faTrash } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import '@rmwc/chip/styles';
import React, { useEffect, useRef, useState } from 'react';
import Spinner from 'react-bootstrap/Spinner';
import toast, { Toaster } from 'react-hot-toast';
import DropDownMultiSelectMFACustom from '../../components/dropDownMultiSelectMFACustom'
import SKUExclusionNewlistAndDelistDialogueBox from '../../components/skuExclusionNewlistAndDelistDialogueBox'
import SKUExclusionNewlistAndDelistFormModal from '../../components/skuExclusionNewlistAndDelistFormModal';
import TableSKUExclusionNewlistAndDelist from '../../components/tableSKUExclusionNewlistAndDelist';
import { BASE_URL, FILTERS, INPUT_FORMS, DELETE, EXPORT, SKU_PERF, EXCLUSIONS, NEWLISTANDDELIST, QUARTERS } from '../../constant/apiEndpoints';
import { skuExclusionNewlistAndDelistInitialColumnsForm as columns } from '../../constant/constants';
import APIService from '../../services/APIService';
import SKUBanPopupModal from '../../components/skuBanPopupModal';
import SKUSpecificSearchBar from '../../components/skuSpecificSearchBar';
import { skuUtils } from './utils';
import SKUExclusionNewlistDelistMassuploadresultsDialogBox from '../../components/SKUExclusionNewlistDelistMassuploadresultsDialogBox';

const Consolidated2 = (props) => {
    const listingUploadInput = useRef(null);

    const { formId, adminIds } = props;

    const [quarterList, setQuarterList] = React.useState([]);
    const [businessUnitList, setBusinessUnitList] = useState([]);
    const [typeList, setTypeList] = useState([]);
    const [itemCategoryList, setItemCategoryList] = useState([]);
    const [selectedQuarters, setSelectedQuarters] = React.useState([]);
    const [selectedBusinessUnitList, setSelectedBusinessUnitList] = useState([]);
    const [selectedTypeList, setSelectedTypeList] = useState([]);
    const [selectedItemCategoryList, setSelectedItemCategoryList] = useState([]);
    const [selectedList, setSelectedList] = useState([]); //Button Handle
    const [skuExclusionNewlistAndDelistData, setSKUExclusionNewlistAndDelistData] = useState([]); //Table Data Handle
    const [dropDownTimer, setDropDownTimer] = useState(0);
    const [loading, setLoading] = useState(true);
    const [isFormModalOpen, setIsFormModalOpen] = useState(false);
    const [selectedIdToEdit, setSelectedIdToEdit] = useState();
    const [selectedObjToEdit, setSelectedObjToEdit] = useState({});
    const [openDeleteDialogueBox, setOpenDeleteDialogueBox] = useState(false);
    const [selectedBan, setSelectedBan] = useState(null);
    const [selectedBU, setSelectedBU] = useState("");
    const [selectedQuarter, setSelectedQuarter] = useState("");
    const [isBanPopupModalOpen, setIsBanPopupModalOpen] = useState(false);
    const [search, setSearch] = useState("");
    const [previousClosedQuarter, setPreviousClosedQuarter] = useState("");
    const [handleMassUploadModal, setHandleMassUploadModal] = useState(false);
    const [massUploadResults, setMassUploadResults] = useState({});

    const setSelectedListInParent = (value) => {
        setSelectedList(value)
    }

    const handleIsFormModalOpen = (value) => {
        setPreviousClosedQuarter(skuUtils.getPrevQuarter())
        setIsFormModalOpen(value);
        setSelectedIdToEdit();
        setSelectedObjToEdit({});
    }

    const handleDeleteDialogueBox = () => {
        setOpenDeleteDialogueBox(!openDeleteDialogueBox)
    }

    const handleDeleteButton = () => {
        setOpenDeleteDialogueBox(true)
    }

    //Support Function For Filter List
    const createStringFromObjectList = (objs) => {
        let newString = ""
        objs.forEach(item => {
            if (newString.length === 0) {
                newString = item.value
            } else {
                newString = newString + "," + item.value
            }
        });

        return encodeURIComponent(newString)
    }

    //AJAX Call To Load Channel Mapping List
    const loadSKUExclusionNewlistAndDelistDataAPICall = async (selectedQuarterFilter = "", selectedBusinessUnitFilter = "", selectedTypeFilter = "", selectedItemCategoryFilter = "", searchFilter = "") => {
        let url = BASE_URL + INPUT_FORMS + SKU_PERF + EXCLUSIONS + NEWLISTANDDELIST + `?selected_form=${formId}` + selectedQuarterFilter + searchFilter + selectedBusinessUnitFilter + selectedTypeFilter + selectedItemCategoryFilter
        let response = await new APIService().get(url);
        if (response.error) {
            console.log("error in channel exlusion list API", response.results.message)
        } else {
            setSKUExclusionNewlistAndDelistData(response.results);
        }
        setLoading(false);
    }

    const handleDelete = async (comment) => {
        let url = BASE_URL + INPUT_FORMS + SKU_PERF + EXCLUSIONS + NEWLISTANDDELIST + DELETE
        let body = {
            "form_id": formId,
            "ids": selectedList.map((ele) => { return ele.id })
        }
        let response = await new APIService().delete(url, body)
        if (response.error) {
            if (response.status === 400) {
                if (response.results.message.includes("This field may not be blank.")) {
                    toast.error('Comment is required!', { position: 'top-center', className: 'toast-popup', duration: 2000 });
                } else {
                    toast.error('Something went wrong.', { position: 'top-center', className: 'toast-popup', duration: 2000 });
                }
            }
        } else {
            toast.success('Data deleted successfully.', { position: 'top-center', className: 'toast-popup', duration: 1000 });
            loadQuarterList()
            loadBusinessUnitList()
            loadTypeList()
            loadItemCategoryList()
            loadSKUExclusionNewlistAndDelistData(true, selectedQuarters, selectedBusinessUnitList, selectedTypeList, selectedItemCategoryList, search);
            handleDeleteDialogueBox();
            setSelectedList([])
        }
    }
    const handleExportButton = async () => {

        //Quarter Filter
        let selectedQuarterFilter = getQuarterFilter(null)
        //Business Unit filter
        let selectedBusinessUnitFilter = getBusinessUnitFilter(null)
        //Type filter
        let selectedTypeFilter = getTypeFilter(null)
        //Item Category Filter
        let selectedItemCategoryFilter = getItemCategoryFilter(null)

        let url = BASE_URL + INPUT_FORMS + SKU_PERF + EXCLUSIONS + NEWLISTANDDELIST + EXPORT + `?selected_form=${formId}` + selectedQuarterFilter + selectedBusinessUnitFilter + selectedTypeFilter + selectedItemCategoryFilter
        fetch(url, {
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/x-www-form-urlencoded",
                Authorization: `Bearer ${JSON.parse(localStorage.getItem('access_token')).access}`,
            })
        }).then(response =>
            response.blob().then(blob => {
                let today = new Date()
                let date = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate()
                let time = today.getHours() + ':' + today.getMinutes() + ':' + today.getSeconds();
                let url = window.URL.createObjectURL(blob);
                let a = document.createElement("a");
                a.href = url;
                a.download = "sku_exclusion_newlistdelist_" + date + "_" + time + ".xls";
                a.click();
            })
        );
    }

    const getQuarterFilter = (quarterIDs) => {
        //Getting User Selected Business Units By State/User Action
        let selectedQuarterList = quarterIDs !== null ? quarterIDs : selectedQuarters
        let selectedQuarterFilter = ""
        if (selectedQuarterList.length !== 0) {
            selectedQuarterFilter = `&selected_quarter=${createStringFromObjectList(selectedQuarterList)}`
        }
        return selectedQuarterFilter
    }

    const getBusinessUnitFilter = (businessUnitIDs) => {
        //Getting User Selected Data By State/User Action
        let selectedBusinessUnit = businessUnitIDs !== null ? businessUnitIDs : selectedBusinessUnitList
        let selectedBusinessUnitListFilter = ""
        if (selectedBusinessUnit.length !== 0) {
            selectedBusinessUnitListFilter = `&selected_business_unit=${createStringFromObjectList(selectedBusinessUnit)}`
        }
        return selectedBusinessUnitListFilter
    }

    const getTypeFilter = (typeIDs) => {
        //Getting User Selected Data By State/User Action
        let selectedType = typeIDs !== null ? typeIDs : selectedTypeList
        let selectedTypeFilter = ""
        if (selectedType.length !== 0) {
            selectedTypeFilter = `&selected_type=${createStringFromObjectList(selectedType)}`
        }
        return selectedTypeFilter
    }

    const getItemCategoryFilter = (itemCategoryIDs) => {
        //Getting User Selected Data By State/User Action
        let selectedItemCategory = itemCategoryIDs !== null ? itemCategoryIDs : selectedItemCategoryList
        let selectedItemCategoryFilter = ""
        if (selectedItemCategory.length !== 0) {
            selectedItemCategoryFilter = `&selected_item_category=${createStringFromObjectList(selectedItemCategory)}`
        }
        return selectedItemCategoryFilter
    }
    const getSearchFilter = (seachFilterArg) => {
        let searchFilter = ""
        if (seachFilterArg.length !== 0) {
            searchFilter = `&search=${encodeURIComponent(seachFilterArg)}`
        }
        return searchFilter
    }
    const loadQuarterList = async (businessUnitIDs = selectedBusinessUnitList, typeIDs = selectedTypeList, itemCategoryIDs = selectedItemCategoryList, searchFilterArg = search) => {
        //Business Unit filter
        let selectedBusinessUnitFilter = getBusinessUnitFilter(businessUnitIDs)
        //Type filter
        let selectedTypeFilter = getTypeFilter(typeIDs)
        //Item Category Filter
        let selectedItemCategoryFilter = getItemCategoryFilter(itemCategoryIDs)
        //Search Filter
        let searchFilter = getSearchFilter(searchFilterArg);

        let url = BASE_URL + INPUT_FORMS + SKU_PERF + EXCLUSIONS + NEWLISTANDDELIST + QUARTERS + `?selected_form=${formId}` + selectedBusinessUnitFilter + selectedTypeFilter + selectedItemCategoryFilter + searchFilter
        let response = await new APIService().get(url);
        if (response.error) {
            console.log("error in Brand List API", response.results.message)
        } else if (response.results.length > 0) {
            setQuarterList(response.results);
        }
    }

    const loadBusinessUnitList = async (quarterIDs = selectedQuarters, typeIDs = selectedTypeList, itemCategoryIDs = selectedItemCategoryList, searchFilterArg = search) => {
        //Quarter Filter
        let selectedQuarterFilter = getQuarterFilter(quarterIDs)
        //Type filter
        let selectedTypeFilter = getTypeFilter(typeIDs)
        //Item Category Filter
        let selectedItemCategoryFilter = getItemCategoryFilter(itemCategoryIDs)
        //Search Filter
        let searchFilter = getSearchFilter(searchFilterArg);

        let url = BASE_URL + INPUT_FORMS + SKU_PERF + EXCLUSIONS + NEWLISTANDDELIST + FILTERS + `?selected_form=${formId}&filter_type=business_unit__name` + selectedQuarterFilter + selectedTypeFilter + selectedItemCategoryFilter + searchFilter
        let response = await new APIService().get(url);
        if (response.error) {
            console.log("error in Brand List API", response.results.message)
        } else if (response.results.length > 0) {
            setBusinessUnitList(response.results);
        }
    }

    //AJAX Call To Load Category SAP List
    const loadTypeList = async (quarterIDs = selectedQuarters, businessUnitIDs = selectedBusinessUnitList, itemCategoryIDs = selectedItemCategoryList, searchFilterArg = search) => {
        //Quarter Filter
        let selectedQuarterFilter = getQuarterFilter(quarterIDs)
        //Business Unit filter
        let selectedBusinessUnitFilter = getBusinessUnitFilter(businessUnitIDs)
        //Item Category Filter
        let selectedItemCategoryFilter = getItemCategoryFilter(itemCategoryIDs)
        //Search Filter
        let searchFilter = getSearchFilter(searchFilterArg);

        let url = BASE_URL + INPUT_FORMS + SKU_PERF + EXCLUSIONS + NEWLISTANDDELIST + FILTERS + `?selected_form=${formId}&filter_type=type__reference_title`+ selectedQuarterFilter + selectedBusinessUnitFilter + selectedItemCategoryFilter + searchFilter
        let response = await new APIService().get(url);
        if (response.error) {
            console.log("error in Brand List API", response.results.message)
        } else if (response.results.length > 0) {
            setTypeList(response.results);
        }
    }
    const loadItemCategoryList = async (quarterIDs = selectedQuarters, businessUnitIDs = selectedBusinessUnitList, typeIDs = selectedTypeList, searchFilterArg = search) => {
        //Quarter Filter
        let selectedQuarterFilter = getQuarterFilter(quarterIDs)
        //Business Unit filter
        let selectedBusinessUnitFilter = getBusinessUnitFilter(businessUnitIDs)
        //Type filter
        let selectedTypeFilter = getTypeFilter(typeIDs)
        //Search Filter
        let searchFilter = getSearchFilter(searchFilterArg);

        let url = BASE_URL + INPUT_FORMS + SKU_PERF + EXCLUSIONS + NEWLISTANDDELIST + FILTERS + `?selected_form=${formId}&filter_type=item_category` + selectedQuarterFilter + selectedBusinessUnitFilter + selectedTypeFilter + searchFilter
        let response = await new APIService().get(url);
        if (response.error) {
            console.log("error in Brand Category Mapping List API", response.results.message)
        } else if (response.results.length > 0) {
            setItemCategoryList(response.results);
        }
    }

    const loadSKUExclusionNewlistAndDelistData = async (useTimer, quarterIDs, businessUnitIDs, typeIDs, itemCategoryIDs, searchFilterArg = "",) => {

        let selectedQuarterFilter = getQuarterFilter(quarterIDs)

        let selectedBusinessUnitFilter = getBusinessUnitFilter(businessUnitIDs)

        let selectedTypeFilter = getTypeFilter(typeIDs)

        let selectedItemCategoryFilter = getItemCategoryFilter(itemCategoryIDs)

        let searchFilter = getSearchFilter(searchFilterArg);

        //Clearing Timeout Before Adding New Timeout(Previous Timeout)
        if (dropDownTimer) {
            clearTimeout(dropDownTimer);
        }
        //Add Timeout Before Hitting API
        if (useTimer) {
            setDropDownTimer(
                setTimeout(function () {
                    toast.promise(loadSKUExclusionNewlistAndDelistDataAPICall(selectedQuarterFilter, selectedBusinessUnitFilter, selectedTypeFilter, selectedItemCategoryFilter, searchFilter), {
                        loading: "Loading. wait a moment!",
                        success: 'Data load success.',
                        error: 'Something went wrong.',
                    },
                        {
                            position: 'top-center',
                            className: 'toast-popup',
                        });
                }, 1500)
            )
        } else {
            loadSKUExclusionNewlistAndDelistDataAPICall();
        }
    }
    const handleSearchSubmit = (search) => {
        setSearch(search);
        loadBusinessUnitList(selectedQuarters, selectedTypeList, selectedItemCategoryList, search);
        loadTypeList(selectedQuarters, selectedBusinessUnitList, selectedItemCategoryList, search);
        loadItemCategoryList(selectedQuarters, selectedBusinessUnitList, selectedTypeList, search);
        loadSKUExclusionNewlistAndDelistData(true, selectedQuarters, selectedBusinessUnitList, selectedTypeList, selectedItemCategoryList, search);
    }
    const handleQuarterSelection = (value) => {
        setSelectedQuarters(value);
        loadBusinessUnitList(value, selectedTypeList, selectedItemCategoryList, search);
        loadTypeList(value, selectedBusinessUnitList, selectedItemCategoryList, search);
        loadItemCategoryList(value, selectedBusinessUnitList, selectedTypeList, search);
        loadSKUExclusionNewlistAndDelistData(true, value, selectedBusinessUnitList, selectedTypeList, selectedItemCategoryList, search);
    }

    const setDropDownValues = (objs, valueType) => {
        if (valueType === "Business Unit") {
            setSelectedBusinessUnitList(objs)
            //To load relevent values in other dropdown filters
            loadQuarterList(objs, selectedTypeList, selectedItemCategoryList, search);
            loadTypeList(selectedQuarters, objs, selectedItemCategoryList, search);
            loadItemCategoryList(selectedQuarters, objs, selectedTypeList, search);
        }
        else if (valueType === "Type(Newlist/Delist)") {
            setSelectedTypeList(objs)
            //To load relevent values in other dropdown filters
            loadQuarterList(selectedBusinessUnitList, objs, selectedItemCategoryList, search);
            loadBusinessUnitList(selectedQuarters, objs, selectedItemCategoryList, search);
            loadItemCategoryList(selectedQuarters, selectedBusinessUnitList, objs, search);
        }
        else if (valueType === "Item Category") {
            setSelectedItemCategoryList(objs)
            //To load relevent values in other dropdown filters
            loadQuarterList(selectedBusinessUnitList, selectedTypeList, objs, search);
            loadBusinessUnitList(selectedQuarters, selectedTypeList, objs, search);
            loadTypeList(selectedQuarters, selectedBusinessUnitList, objs, search);
        }
        //Loading Channel Mapping List In Table
        loadChannelMappingsBasedOnFilters(objs, valueType);
    }


    const loadChannelMappingsBasedOnFilters = (objs, valueType) => {
        //Loading Channel Mapping Values which is dependent on Home OOH Dropdown
        if (valueType === "Business Unit") {
            loadSKUExclusionNewlistAndDelistData(true, selectedQuarters, objs, selectedTypeList, selectedItemCategoryList, search);
        }
        //Loading Channel Mapping Values which is dependent on Trade Channel Dropdown
        if (valueType === "Type(Newlist/Delist)") {
            loadSKUExclusionNewlistAndDelistData(true, selectedQuarters, selectedBusinessUnitList, objs, selectedItemCategoryList, search);
        }
        //Loading Channel Mapping Values which is dependent on Subtrade Channel Dropdown
        if (valueType === "Item Category") {
            loadSKUExclusionNewlistAndDelistData(true, selectedQuarters, selectedBusinessUnitList, selectedTypeList, objs, search);
        }
    }

    const handleEditClickInParent = (obj) => {
        setIsFormModalOpen(true)
        setSelectedIdToEdit(obj.id)
        setSelectedObjToEdit(obj)
    }

    const postSubmitAndEditData = () => {
        loadQuarterList()
        loadBusinessUnitList()
        loadTypeList()
        loadItemCategoryList()
        loadSKUExclusionNewlistAndDelistData(true, selectedQuarters, selectedBusinessUnitList, selectedTypeList, selectedItemCategoryList, search);
    }
    const handleBanPopupModal = (id = null, selectedBU = "", quarter = "") => {
        if (id !== null) {
            setSelectedBan(id)
        }
        if (selectedBU !== "") {
            setSelectedBU(selectedBU)
        }

        if (quarter !== "") {
            setSelectedQuarter(quarter)
        }
        setIsBanPopupModalOpen(!isBanPopupModalOpen)
    }
    //useEffect Method
    useEffect(() => {
        let mounted = true
        if (mounted) {
            loadQuarterList();
            loadBusinessUnitList();
            loadTypeList();
            loadItemCategoryList();
            loadSKUExclusionNewlistAndDelistData(false, selectedQuarters, selectedBusinessUnitList, selectedTypeList, selectedItemCategoryList, search);
        }
        return function cleanup() {
            mounted = false
        }

    }, []);

    const handleMassUpload = async (e) => {
        toast.loading('Submitting, Please Wait!',
            {
                position: 'top-center',
                className: 'toast-popup',
                duration: 1000,
            });
        const result = await skuUtils.constructMassUploadData(e, 'formsku');
        if (result.results.items_failed?.length === 0) {
            toast.success('Data submitted Successfully.', { position: 'top-center', className: 'toast-popup', duration: 1000, });
            if (result.results.total_added > 0) postSubmitAndEditData();
        } else {
            setMassUploadResults(result.results);
            setHandleMassUploadModal(true);
        }
    }

    return (
        <div className="user-view-container">
            <div className="brand-category-header-container row">
                <div className="col-9 brand-category-filter-container">
                    <div className="brand-category-dropdown-container w-25">
                        <DropDownMultiSelectMFACustom title="Quarter" options={quarterList} setParentDropdownValue={handleQuarterSelection} />
                    </div>
                    <div className="brand-category-dropdown-container w-25">
                        <DropDownMultiSelectMFACustom title="Business Unit" options={businessUnitList} setParentDropdownValue={setDropDownValues} />
                    </div>
                    <div className="brand-category-dropdown-container w-25">
                        <DropDownMultiSelectMFACustom title="Type(Newlist/Delist)" options={typeList} setParentDropdownValue={setDropDownValues} />
                    </div>
                    <div className="brand-category-dropdown-container w-25">
                        <DropDownMultiSelectMFACustom title="Item Category" options={itemCategoryList} setParentDropdownValue={setDropDownValues} />
                    </div>
                    <div className="col-3 p-0 seach-box-container">
                        <SKUSpecificSearchBar handleSearchSubmit={handleSearchSubmit} />
                    </div>
                </div>
                    <div className="col-3 brand-category-add-delete-export-button-container">
                        <button className="brand-category-export-button mt-3 col" type="button" value="Export Data" onClick={handleExportButton}>Export</button>
                        <input
                            className="brand-category-button mt-3 col"
                            type="button"
                            value="Import"
                            onClick={() => {
                                listingUploadInput.current?.click();
                            }}
                        />

                        <input
                            ref={listingUploadInput}
                            id="for-sku"
                            style={{display: 'none'}}
                            type="file"
                            accept=".xls"
                            onClick={(e) => {
                                const { target = {} } = e || {};
                                target.value = "";
                            }}
                            onChange={handleMassUpload}
                        />
                        {selectedList.length === 0 ?
                             <button className="brand-category-button mt-3 col" type="button" value="+ Add New" onClick={() => handleIsFormModalOpen(true)}><FontAwesomeIcon icon={faPlus} className="search-icon" size="1x" /> Add New</button>
                            : <button className="brand-category-button mt-3 col" type="button" value="Delete" onClick={handleDeleteButton}><FontAwesomeIcon icon={faTrash} className="search-icon" size="1x" /> Delete</button>}
                    </div>
            </div>
            <div className="brand-category-body">
                <div className='other-mfa-table-holder'>
                    <div className='channel-category-chips-container'>
                            {/* CSS Purpose */}
                    </div>
                    {/* Loader(While Data Loading) */}
                    {loading ? <div className="table-data-note"><Spinner animation="border" />
                        <p></p>
                    </div> : ""}
                    {/* Loader(While Data Loading) */}
                    
                    {skuExclusionNewlistAndDelistData.length > 0 ?
                        <div className="brand-category-table-container">
                            <TableSKUExclusionNewlistAndDelist columns={columns}
                                handleBanPopupModal={handleBanPopupModal}
                                skuExclusionNewlistAndDelistData={skuExclusionNewlistAndDelistData}
                                setSelectedListInParent={setSelectedListInParent}
                                handleEditClickInParent={handleEditClickInParent}
                                formId={formId}
                            />
                        </div>
                        : ''}
                    {/* No Data Message */}
                    {skuExclusionNewlistAndDelistData.length === 0 && loading === false ? (<div className="table-data-note"><p>No data found.</p>
                        <p></p>
                    </div>) : ""}
                    {/* No Data Message */}
                </div>
{/* Ban Popup Modal */}
            {isBanPopupModalOpen ?
                <SKUBanPopupModal isBanPopupModalOpen={isBanPopupModalOpen} handleBanPopupModal={handleBanPopupModal}
                    ban_number={selectedBan} business_unit={selectedBU} selectedForm={formId} current_quarter={selectedQuarter}
                />
                : ""}
            {/* Ban Popup Modal */}
            </div>
            {/* Loader */}
            <Toaster />
            {/* Loader */}
            {isFormModalOpen ?
                <SKUExclusionNewlistAndDelistFormModal
                    isFormModalOpen={isFormModalOpen}
                    handleIsFormModalOpen={handleIsFormModalOpen}
                    formId={formId}
                    selectedIdToEdit={selectedIdToEdit}
                    selectedObjToEdit={selectedObjToEdit}
                    postSubmitAndEditData={postSubmitAndEditData}
                    previousClosedQuarter={previousClosedQuarter}
                />
                : ""}
            {/* Message Dialogue Box */}
            {openDeleteDialogueBox ? <SKUExclusionNewlistAndDelistDialogueBox openDialogueBox={openDeleteDialogueBox}
                handleDeleteDialogueBox={handleDeleteDialogueBox}
                messageType="Delete"
                message="Are you sure you want to delete"
                handleDelete={handleDelete} /> : ""}
            {/* Message Dialogue Box */}
            
            <SKUExclusionNewlistDelistMassuploadresultsDialogBox
                open={handleMassUploadModal}
                data={massUploadResults}
                handleDialogueBox={() => {
                    if (massUploadResults.total_added > 0) {
                        postSubmitAndEditData();
                    }
                    setHandleMassUploadModal(false);
                    setMassUploadResults(null);
                }}
            />

        </div>
    );

};

export default Consolidated2;